var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransportCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246,
    height: 177,
    viewBox: "0 0 246 177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M-349.845-243.426h46.034a2.3,2.3,0,0,0,2.3-2.3v-21.44a2.3,2.3,0,0,0-2.3-2.3h-29.8a2.3,2.3,0,0,0-1.833.911l-16.231,21.439A2.3,2.3,0,0,0-349.845-243.426Z",
    transform: "translate(352.148 269.463)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 177
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(-11123.27 8283.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M-321.459-360.624c-66.936,3.214-81.705,15.281-69.042,60.343s-48.9,27.986-44.538,65.911,148.9,55.167,200.858,19.117,5-49.834-12.346-91.334S-272.5-362.975-321.459-360.624Z",
    transform: "translate(11570.613 -7913.553)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(11128 -8237.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M-217.616-205.5h-2.976v-71.171a4.444,4.444,0,0,0-4.444-4.444H-328.2V-205.5h0v-75.617s-37.731-.875-41.042,0-26.473,32-26.473,32-19.2,8.382-20.969,11.259a12.251,12.251,0,0,0-.808,3.5c-.231,1.607-.452,3.637-.645,5.889-.682,7.861-1.145,18.4-1.328,22.97h-5.341a3.16,3.16,0,0,0-3.166,3.157v1.616a3.166,3.166,0,0,0,3.166,3.166h30.814a17.652,17.652,0,0,0,17.652,17.652,17.652,17.652,0,0,0,17.652-17.652h74.8a17.652,17.652,0,0,0,17.652,17.652,17.652,17.652,0,0,0,17.652-17.652h30.965a1.535,1.535,0,0,0,1.535-1.534v-4.87A1.535,1.535,0,0,0-217.616-205.5Z",
    transform: "translate(427.972 281.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M-34.506-275.088H-51.059a.57.57,0,0,0-.57.57.57.57,0,0,0,.57.57h16.554a.57.57,0,0,0,.57-.57A.57.57,0,0,0-34.506-275.088Z",
    transform: "translate(266.117 278.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M-36.117-265.916H-51.059a.57.57,0,0,0-.57.57.57.57,0,0,0,.57.57h14.942a.57.57,0,0,0,.57-.57A.57.57,0,0,0-36.117-265.916Z",
    transform: "translate(266.117 274.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M-36.117-256.744H-51.059a.57.57,0,0,0-.57.57.569.569,0,0,0,.57.57h14.942a.57.57,0,0,0,.57-.57A.57.57,0,0,0-36.117-256.744Z",
    transform: "translate(266.117 270.857)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(11128 -8237.652)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(8.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(91.354 0.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    d: "M0,0H99.81a7.8,7.8,0,0,1,7.8,7.8V76.981a6.573,6.573,0,0,1-6.573,6.573H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#a00b0b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(11.649 11.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M-147.51-258.128h-84a.962.962,0,0,1-.963-.962.963.963,0,0,1,.963-.963h84a.962.962,0,0,1,.962.963A.962.962,0,0,1-147.51-258.128Z",
    transform: "translate(232.468 260.053)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M-147.51-234.9h-84a.962.962,0,0,1-.963-.962.962.962,0,0,1,.963-.962h84a.962.962,0,0,1,.962.962A.962.962,0,0,1-147.51-234.9Z",
    transform: "translate(232.468 250.062)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M-147.51-211.668h-84a.962.962,0,0,1-.963-.962.963.963,0,0,1,.963-.963h84a.962.962,0,0,1,.962.963A.962.962,0,0,1-147.51-211.668Z",
    transform: "translate(232.468 240.072)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M-147.51-188.438h-84a.963.963,0,0,1-.963-.963.962.962,0,0,1,.963-.962h84a.962.962,0,0,1,.962.962A.962.962,0,0,1-147.51-188.438Z",
    transform: "translate(232.468 230.081)",
    fill: "#cf3030"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M-321.847-281.118v77.9H-413.2s.52-14.935,1.415-25.251c.193-2.252.414-4.282.645-5.889a12.247,12.247,0,0,1,.808-3.5c1.771-2.878,20.969-11.259,20.969-11.259s23.162-31.111,26.473-32S-321.847-281.118-321.847-281.118Z",
    transform: "translate(413.198 281.507)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M-397.311-199.517c0,2.925-5.2,5.457-13.4,5.716.193-2.252.414-4.282.645-5.889C-407.2-200.286-397.311-202.163-397.311-199.517Z",
    transform: "translate(412.131 246.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(34.794 6.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M-303.811-269.463h-29.8a2.3,2.3,0,0,0-1.833.911l-16.231,21.439a2.3,2.3,0,0,0,1.833,3.686h46.034a2.3,2.3,0,0,0,2.3-2.3v-21.44A2.3,2.3,0,0,0-303.811-269.463Z",
    transform: "translate(352.148 269.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M-349.845-243.426h46.034a2.3,2.3,0,0,0,2.3-2.3v-21.44a2.3,2.3,0,0,0-2.3-2.3h-29.8a2.3,2.3,0,0,0-1.833.911l-16.231,21.439A2.3,2.3,0,0,0-349.845-243.426Z",
    transform: "translate(352.148 269.463)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(16.535 0.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(7.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M-293.792-252.157s-1.592-3.331-.829-5.367c0,0-4.378-4.065-8.223-3.353a26.348,26.348,0,0,0-1.3,4.5c-.006,1,.828,3.891,1.609,4.277s4-.112,4-.112,1.574,2.389,2.322,2.692Z",
    transform: "translate(307.111 264.87)",
    fill: "#e7ac8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M-297.269-260.277a.752.752,0,0,0,1.007-.448c.491-1.445,1.158-4.623-1.67-6.262-3.086-1.788-5.742-.438-7.269,1.632-.264.02-3.53-1.567-4.133-.4,0,0-.4.546,2.655,1.661C-304.218-263.2-299.139-261.066-297.269-260.277Z",
    transform: "translate(309.351 267.819)",
    fill: "#2f3235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M-304.58-253.579s3.684-1.311,9.559.278l.009.327a18.152,18.152,0,0,0-3.561-.435,12,12,0,0,1,.26,2.386,20.709,20.709,0,0,0,3.526-.488l.1.373a23.4,23.4,0,0,1-8.387,1.664S-304.746-250.293-304.58-253.579Z",
    transform: "translate(307.304 261.913)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(0 11.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(2.363 9.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M-300.519-230.2l-2.088,5.393-9.045-1.236-.6,2.772s9.326,3.852,11.621,2.11,3.857-7.788,3.857-7.788Z",
    transform: "translate(316.092 230.202)",
    fill: "#d39479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M-314.152-223.053a2.632,2.632,0,0,0-2.9-1.339c-2.016.439-2.073,2.359-1.846,2.462s.518-.719.518-.719a1.126,1.126,0,0,0,.838,1.338c1.05.24,1.051-.135,1.385-.119.167.008,1.1.928,1.5.664S-314.152-223.053-314.152-223.053Z",
    transform: "translate(318.99 227.734)",
    fill: "#d39479"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M-276.364-225.254c-1.123.088-9.234.393-14.146-1.259,0,0-4.776-17.182-3.526-18.746s3.355-3.342,5.614-1.957,5.556,3.148,6.921,5.83S-276.364-225.254-276.364-225.254Z",
    transform: "translate(310.71 247.715)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    transform: "translate(0 2.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(0 6.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M-304.857-232.162l-1.866,5.475-9.088-.866-.486,2.794s9.475,3.467,11.7,1.633,3.535-7.939,3.535-7.939Z",
    transform: "translate(320.195 232.162)",
    fill: "#e7ac8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M-318.333-224.18a2.633,2.633,0,0,0-2.953-1.22c-2,.521-1.974,2.442-1.745,2.536s.488-.74.488-.74a1.127,1.127,0,0,0,.893,1.3c1.059.2,1.045-.178,1.379-.176.167,0,1.14.882,1.522.6S-318.333-224.18-318.333-224.18Z",
    transform: "translate(323.136 229.296)",
    fill: "#e7ac8d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M-295.422-243.406a15.049,15.049,0,0,0-2.046,6.959,9.721,9.721,0,0,0,4.411,1.463l1.572-6.816Z",
    transform: "translate(312.096 243.406)",
    fill: "#cf3030"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M-350.27-228.505a1.724,1.724,0,0,1-1.3-3c3.31-2.928,7.959-6.429,8.491-3.538C-342.37-231.207-343.112-229.076-350.27-228.505Z",
    transform: "translate(352.148 255.125)",
    fill: "#a00b0b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M-274.546-211.55h-9.268a1.443,1.443,0,0,1-1.444-1.443,1.443,1.443,0,0,1,1.444-1.444h9.268a1.443,1.443,0,0,1,1.444,1.444A1.443,1.443,0,0,1-274.546-211.55Z",
    transform: "translate(358.174 252.662)",
    fill: "#a00b0b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(0 61.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M-216.081-146.61v4.87a1.535,1.535,0,0,1-1.535,1.534h-207.19a3.166,3.166,0,0,1-3.166-3.166v-1.616a3.16,3.16,0,0,1,3.166-3.157h207.19A1.535,1.535,0,0,1-216.081-146.61Z",
    transform: "translate(427.972 162.194)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(29.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M-331.981-150.808h-43.987a21.573,21.573,0,0,1,1.491-7.939,21.964,21.964,0,0,1,20.5-14.049,21.976,21.976,0,0,1,20.507,14.049A21.571,21.571,0,0,1-331.981-150.808Z",
    transform: "translate(375.968 172.796)",
    fill: "#2f3235"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(4.341 4.337)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 17.652,
    cy: 17.652,
    r: 17.652
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(10.15 10.15)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 7.502,
    cy: 7.502,
    r: 7.502,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(110.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M-138.787-150.808h-43.986a21.572,21.572,0,0,1,1.492-7.939,21.963,21.963,0,0,1,20.5-14.049,21.976,21.976,0,0,1,20.507,14.049A21.56,21.56,0,0,1-138.787-150.808Z",
    transform: "translate(182.773 172.796)",
    fill: "#2f3235"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(4.34 4.337)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 17.652,
    cy: 17.652,
    r: 17.652
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(10.15 10.15)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 7.502,
    cy: 7.502,
    r: 7.502,
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(214.488 3.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M-34.506-273.948H-51.059a.57.57,0,0,1-.57-.57.57.57,0,0,1,.57-.57h16.554a.57.57,0,0,1,.57.57A.57.57,0,0,1-34.506-273.948Z",
    transform: "translate(51.629 275.088)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    transform: "translate(0 5.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M-36.117-264.776H-51.059a.57.57,0,0,1-.57-.57.57.57,0,0,1,.57-.57h14.942a.57.57,0,0,1,.57.57A.57.57,0,0,1-36.117-264.776Z",
    transform: "translate(51.629 265.916)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(0 10.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M-36.117-255.6H-51.059a.569.569,0,0,1-.57-.57.57.57,0,0,1,.57-.57h14.942a.57.57,0,0,1,.57.57A.57.57,0,0,1-36.117-255.6Z",
    transform: "translate(51.629 256.744)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(11191.827 -8202.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(0 14.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(0 7.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(0 38.148)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 13.828,
    cy: 13.828,
    r: 13.828,
    transform: "translate(0 19.556) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(13.679 13.679)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 5.877,
    cy: 5.877,
    r: 5.877,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(77.612 41.216)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 13.828,
    cy: 13.828,
    r: 13.828,
    transform: "translate(0 27.004) rotate(-77.533)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(10.61 10.61)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 5.877,
    cy: 5.877,
    r: 5.877,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(3.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(0 12.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M-289.314-119.416s-15.647-1.012-20.022,15.625h20.022Z",
    transform: "translate(309.335 143.385)",
    fill: "#a00b0b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(15.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M-259.175-95.051h43.019v3.019h-43.019Z",
    transform: "translate(271.995 132.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M-231.656-141.244a13.986,13.986,0,0,0,4.531,10.625v9.062h-39.687s.313-22.969,6.875-37.812c-1.148-1.767-2.862-2.5-5.312-1.875,0,0-14.738,16.823-16.409,39.584a3.868,3.868,0,0,0,3.846,4.166h90.061s2.263-17.105-8.363-23.667Z",
    transform: "translate(281.669 161.462)",
    fill: "#cf3030"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M-163.222-118.288s-16.1-.381-16.1,15.394h32.207C-147.119-118.669-163.222-118.288-163.222-118.288Z",
    transform: "translate(253.422 142.894)",
    fill: "#a00b0b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(27.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M-250-171.352a1.267,1.267,0,0,1-1.25-1.069,1.267,1.267,0,0,1,1.054-1.45l7.687-1.216a1.266,1.266,0,0,1,1.449,1.054,1.267,1.267,0,0,1-1.054,1.45l-7.686,1.216A1.255,1.255,0,0,1-250-171.352Z",
    transform: "translate(257.29 179.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M-258.907-182.736s-6.589,5.912,0,11.172l2.344-5Z",
    transform: "translate(261.835 182.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M-256.7-182.736v11.172l2.187,1.172,5.312,1.875S-243.494-182.736-256.7-182.736Z",
    transform: "translate(259.625 182.736)",
    fill: "#a00b0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M-244.808-165.881a1.436,1.436,0,0,1-.881-.3l-5.325-4.11a1.443,1.443,0,0,1-.261-2.025,1.443,1.443,0,0,1,2.024-.26l5.325,4.109a1.444,1.444,0,0,1,.262,2.025A1.442,1.442,0,0,1-244.808-165.881Z",
    transform: "translate(257.423 178.496)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 40.429,
    height: 8.379,
    rx: 2.938,
    transform: "translate(62.519 24.824)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(78.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(5.464 0.481)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 33.689,
    height: 31.461,
    rx: 3.36,
    fill: "#a00b0b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(4.621 7.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M-136.147-180.087h-23.828a.241.241,0,0,1-.24-.241.241.241,0,0,1,.24-.241h23.828a.241.241,0,0,1,.24.241A.241.241,0,0,1-136.147-180.087Z",
    transform: "translate(160.216 180.568)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M-136.147-171.176h-23.828a.241.241,0,0,1-.24-.241.241.241,0,0,1,.24-.241h23.828a.241.241,0,0,1,.24.241A.241.241,0,0,1-136.147-171.176Z",
    transform: "translate(160.216 176.736)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M-136.147-162.267h-23.828a.24.24,0,0,1-.24-.241.241.241,0,0,1,.24-.241h23.828a.241.241,0,0,1,.24.241A.24.24,0,0,1-136.147-162.267Z",
    transform: "translate(160.216 172.904)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M-136.147-153.357h-23.828a.241.241,0,0,1-.24-.241.241.241,0,0,1,.24-.24h23.828a.241.241,0,0,1,.24.24A.241.241,0,0,1-136.147-153.357Z",
    transform: "translate(160.216 169.072)",
    fill: "#cf3030"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M-177.429-154.425a.481.481,0,0,1-.226-.056.481.481,0,0,1-.2-.65l21.093-39.84a.481.481,0,0,1,.65-.2.481.481,0,0,1,.2.65L-177-154.68A.479.479,0,0,1-177.429-154.425Z",
    transform: "translate(177.911 195.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M-151.247-154.424a.475.475,0,0,1-.122-.016.48.48,0,0,1-.343-.587l10.469-39.84a.482.482,0,0,1,.587-.343.48.48,0,0,1,.343.588l-10.468,39.84A.481.481,0,0,1-151.247-154.424Z",
    transform: "translate(166.65 195.226)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(39.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(12.387 33.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M-214.075-103.607l-.038,3.936s-10.225,1.577-10.76.687,5.144-3.394,6.008-3.553.828-1.346.828-1.346Z",
    transform: "translate(224.908 136.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M-191.407-152.228l-15.5,4.989-2.67,19.191-4.89-.215s-2.7-18.26,2.546-23.383,20.7-10.257,20.7-10.257Z",
    transform: "translate(220.717 161.904)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(11.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M-207.178-202.388s-2.117-3.758-1.4-6.2c0,0-5.407-4.387-9.809-3.242a30.974,30.974,0,0,0-1.141,5.358c.073,1.171,1.275,4.474,2.213,4.86s4.633-.457,4.633-.457,2.02,2.659,2.912,2.952Z",
    transform: "translate(223.486 216.85)",
    fill: "#e7ac8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M-212.019-211.969a.874.874,0,0,0,1.132-.6c.452-1.727.969-5.49-2.444-7.172-3.724-1.835-6.7-.043-8.3,2.5-.305.045-4.221-1.541-4.827-.132,0,0-.414.669,3.214,1.722C-220.315-214.809-214.251-212.737-212.019-211.969Z",
    transform: "translate(226.472 220.497)",
    fill: "#2f3235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M-220.044-203.3s4.167-1.831,11.11-.456l.037.38a21.008,21.008,0,0,0-4.166-.217,14.1,14.1,0,0,1,.5,2.764,23.961,23.961,0,0,0,4.05-.857l.142.427a27.082,27.082,0,0,1-9.594,2.627S-219.97-199.453-220.044-203.3Z",
    transform: "translate(223.708 213.517)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(0 37.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M-234.937-102.755l-1.689,3.552s-9.907-2.952-10.016-3.987,6.077-.874,6.925-.648,1.314-.866,1.314-.866Z",
    transform: "translate(246.643 133.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M-205.34-146.364l-13.037.8-10.659,21.433-4.648-2.267s4.368-19.607,9.763-24.787,27.384-4.161,27.384-4.161h0A9.418,9.418,0,0,1-205.34-146.364Z",
    transform: "translate(241.069 155.423)",
    fill: "#2f3235"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(1.06 13.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(3.82 9.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M-216.1-181.217l-3.217,5.948-10.246-2.774-1.108,3.127s10.177,5.85,13.087,4.17,5.616-8.465,5.616-8.465Z",
    transform: "translate(234.895 181.217)",
    fill: "#d39479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M-232.371-175.987a3.054,3.054,0,0,0-3.144-1.983c-2.391.211-2.745,2.43-2.5,2.583s.7-.758.7-.758a1.319,1.319,0,0,0,.766,1.677c1.176.434,1.233,0,1.615.067.192.034,1.133,1.24,1.627.992S-232.371-175.987-232.371-175.987Z",
    transform: "translate(238.081 179.827)",
    fill: "#d39479"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M-184.855-172.525c-1.295.195-10.679,1.212-16.51-.315,0,0-6.933-19.663-5.609-21.591s3.62-4.174,6.352-2.742,6.7,3.221,8.5,6.24S-184.855-172.525-184.855-172.525Z",
    transform: "translate(228.595 197.626)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(0 3.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(0 8.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M-223.122-176.473l-2.668,6.216-10.455-1.832-.821,3.214s10.665,4.9,13.411,2.964,4.829-8.939,4.829-8.939Z",
    transform: "translate(241.464 176.473)",
    fill: "#e7ac8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M-239.125-169a3.053,3.053,0,0,0-3.31-1.69c-2.363.428-2.515,2.669-2.256,2.8s.634-.819.634-.819a1.318,1.318,0,0,0,.914,1.6c1.21.326,1.228-.112,1.615-.079.194.016,1.24,1.132,1.709.84S-239.125-169-239.125-169Z",
    transform: "translate(244.783 174.01)",
    fill: "#e7ac8d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M-209.979-192.019c-1.623,2.42-3.783,6.448-4.15,9.438,0,0,2.685,2.006,4.978,2.105l3.28-7.781Z",
    transform: "translate(231.6 192.019)",
    fill: "#cf3030"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(120.841 16.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M-86.829-190.267h-16.554a.57.57,0,0,1-.57-.57.57.57,0,0,1,.57-.57h16.554a.57.57,0,0,1,.57.57A.57.57,0,0,1-86.829-190.267Z",
    transform: "translate(103.952 191.407)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(0 5.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M-88.44-181.1h-14.942a.57.57,0,0,1-.57-.57.57.57,0,0,1,.57-.57H-88.44a.57.57,0,0,1,.57.57A.57.57,0,0,1-88.44-181.1Z",
    transform: "translate(103.952 182.235)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(0 10.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M-88.44-171.924h-14.942a.57.57,0,0,1-.57-.57.57.57,0,0,1,.57-.57H-88.44a.57.57,0,0,1,.57.57A.57.57,0,0,1-88.44-171.924Z",
    transform: "translate(103.952 173.064)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportCar);
export default __webpack_public_path__ + "static/media/transport-car.52a5b0058f3b40a926b74c8e5eadad0f.svg";
export { ForwardRef as ReactComponent };